import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';

import AppZlapdashThesis from '@/views/AppZlapdashThesis.vue';

// import usePermission from '@/usePermission';

import Login from '../views/Login.vue';
import Logout from '../views/Logout.vue';

import Dashboard from '../views/Dashboard.vue';
import ComponentList from '../views/Component/List.vue';
import ComponentNew from '../views/Component/New.vue';
import ComponentEdit from '../views/Component/Edit.vue';

Vue.use(VueRouter);

const guardAuth = async (to: Route, from: Route, next: (route?: any) => void) => {
  next();
  // if (localStorage.getItem('apollo-token')) {
  //   next(); // TODO: implement token expire check
  // } else {
  //   next({ name: 'Login' });
  // }
};

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/app',
    beforeEnter: guardAuth, // Check only root, no need to check children
    component: AppZlapdashThesis,
    children: [
      {
        path: '',
        name: 'Dashboard',
        redirect: '/app/components',
        // component: Dashboard,
      },
      {
        path: 'components',
        name: 'ComponentList',
        component: ComponentList,
      },
      {
        path: 'components/:id',
        name: 'ComponentView',
        component: ComponentList,
      },
      {
        path: 'components/new',
        name: 'ComponentNew',
        component: ComponentNew,
      },
      {
        path: 'components/edit/:id',
        name: 'ComponentEdit',
        component: ComponentEdit,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
